export * from './cache';
export * from './types';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-cache/lib/index.js
// module id = 267
// module chunks = 0